import { Key, ReactNode } from "react";

export type LabelValue = {
  label: string;
  value: string;
};

export type LabelValueNumber = {
  label: string;
  value: number;
};

export const DateFormats = [
  "fullDate",
  "date",
  "datetime",
  "relativeTime",
] as const;
export type DateFormatType = (typeof DateFormats)[number];

export type DateFormatter = {
  getFormat: (key: Key) => DateFormatType;
  setFormat: (key: Key, format: DateFormatType) => void;
  render: (key: Key, value: string | number) => ReactNode;
};

export type GroupStatsResponse = Record<string, Record<string, number>>;
